import { Box, Button, Typography, Grid } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { useStyles } from './styles';
import moment from 'moment';
import { decrypt } from '../../helpers/encrypt';
import { maskAccountNo, isAdmin } from '../../helpers';
import Cookies from 'js-cookie';
import InfoIcon from '@material-ui/icons/Info';

export const ReviewAutopayPayment = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const {paymentData, bankData, handleCloseReviewPopup, handleContinueReviewPopup, selectedDate} = props;
  
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const calculateTotal = () => {
    if (paymentData.paymentFrequncyType === "M") {
      return parseFloat(paymentData.regularPayment + Number(paymentData.additionalEscrow) + Number(paymentData.additionalPrincipal)).toFixed(2);
    }
    return parseFloat(paymentData.weeklyPayment + Number(paymentData.additionalEscrow) + Number(paymentData.additionalPrincipal)).toFixed(2)
  }
 
  return (
    <Dialog fullScreen={fullScreen} PaperProps={{ classes: { root: classes.dialogStyle }}} open={true}>
      <Box className={classes.root}>
        <Box className={classes.cardBody}>
          <Typography className={classes.statusTitle}>Review & Confirm Autopay</Typography>
        </Box>
        
        <Box className={classes.cardBody2}>
          
        {(moment(paymentData.paymentDueDate).format('YYYY-MM-DD')) < (moment(selectedDate).format('YYYY-MM-DD')) && <Box className={classes.paymentReflectBox}>
           <Box display='flex'>
            <InfoIcon className={classes.infoIcon} />
            <Box>
              <Typography className={classes.informationText}>Please note that your first scheduled autopay date of <b>{moment(selectedDate).format("ll")}</b> occurs after your payment due date of <b>{moment(paymentData.paymentDueDate).format('ll')}</b>.</Typography>
              <Typography className={classes.informationText}>Please ensure that any payments due prior to the start of the ACH drafts are submitted separately. Failure to do so may result in late fees and/or delinquent credit reporting.</Typography>
             </Box>
           </Box>
          </Box> }

          <Box className={classes.statusContainer}>
           <Box className={classes.cardContainer}>
            <Box className={classes.imageContainer}>
              <Typography className={classes.paragraph}>
              <Grid container>
                <Grid item md={6} xs={6} lg={6}  style={{textAlign :"end"}}>
                  <span className={classes.detail}>{(paymentData.paymentFrequncyType === 'B') ? 'First Draft Date' : 'Draft Date'}:</span> </Grid>
                  <Grid item md={6} xs={6} lg={6}   style={{textAlign :"start"}}
>
                  <span className={classes.paymentDetail}>{moment(selectedDate).format("ll")}</span></Grid></Grid></Typography>

               { (paymentData.paymentFrequncyType === 'B') && 
               <Typography className={classes.paragraph}>
               <Grid container>
                <Grid item md={6} xs={6} lg={6} style={{textAlign :"end"}}> <span className={classes.detail}>Second Draft Date:</span> </Grid>
                <Grid item md={6} xs={6} lg={6}   style={{textAlign :"start"}}><span className={classes.paymentDetail}>{moment(paymentData.draftDate2).format("ll")}</span></Grid></Grid></Typography> }
         
               <Typography className={classes.paragraph}>
               <Grid container>
                <Grid item md={6} xs={6} lg={6} style={{textAlign :"end"}}> <span className={classes.detail}>Payment Frequency:</span> </Grid>
                <Grid item md={6} xs={6} lg={6}   style={{textAlign :"start"}}><span className={classes.paymentDetail}>{(paymentData.paymentFrequncyType === "M") ? "Regular Monthly" : "Bi-Weekly"}</span></Grid></Grid>
              </Typography>

             {bankData?.bankName && <Typography className={classes.paragraph}>
             <Grid container alignItems='flex-start'>
                <Grid item md={6} xs={6} lg={6} style={{textAlign :"end"}}> <span className={classes.detail}>Bank Account:</span> </Grid>
                <Grid item md={6} xs={6} lg={6} style={{textAlign :"start", paddingLeft: 6}}><span className={classes.paymentDetail} style={{paddingLeft: 0}}>{decrypt(bankData?.bankName)},{maskAccountNo(decrypt(bankData?.bankAccountNumber))}</span></Grid></Grid></Typography>}
              </Box>
            </Box> 

            <Box className={classes.cardContainer}>
              <Box className={classes.container}>
              
              <Typography className={classes.paragraph}>
              <Grid container>
                <Grid item md={6} xs={6} lg={6} style={{textAlign :"end"}}><span className={classes.detail}>{paymentData.paymentFrequncyType === "M" ? "Regular Monthly Payment" : "Bi-Weekly Payment"}: </span></Grid>
                <Grid item md={6} xs={6} lg={6} style={{textAlign :"start"}}><span className={classes.paymentDetail}>{paymentData.paymentFrequncyType === "M" ? `$${numberWithCommas(paymentData.regularPayment.toFixed(2))}` : `$${numberWithCommas(paymentData.weeklyPayment.toFixed(2))}`}</span></Grid></Grid></Typography>
              {(paymentData?.additionalPrincipal !== 0) && <Typography className={classes.paragraph}>
              <Grid container>
                <Grid item md={6} xs={6} lg={6} style={{textAlign :"end"}}><span className={classes.detail}>Additional Principal Amount: </span></Grid>
                <Grid item md={6} xs={6} lg={6} style={{textAlign :"start"}}><span className={classes.paymentDetail}> ${numberWithCommas(parseFloat(paymentData?.additionalPrincipal).toFixed(2))}</span></Grid></Grid></Typography>}
              {(paymentData?.additionalEscrow !== 0) && <Typography className={classes.paragraph}>
              <Grid container>
                <Grid item md={6} xs={6} lg={6} style={{textAlign :"end"}}><span className={classes.detail}>Additional Escrow Amount:</span> </Grid>
                <Grid item md={6} xs={6} lg={6} style={{textAlign :"start"}}><span className={classes.paymentDetail}>${numberWithCommas(parseFloat(paymentData.additionalEscrow).toFixed(2))}</span></Grid></Grid></Typography>}
             
              </Box>
            </Box> 

            <Box className={classes.totalCardContainer}>
              <Box className={classes.container}>
               <Typography className={classes.paragraph}>
               <Grid container>
                <Grid item md={6} xs={6} lg={6} style={{textAlign :"end"}}><span className={classes.paymentTotal}>Payment Total: </span> </Grid>
                <Grid item md={6} xs={6} lg={6} style={{textAlign :"start"}}><span className={classes.paymentTotalDetails}>${numberWithCommas(calculateTotal())}</span></Grid></Grid>
                </Typography>
              </Box>
            </Box> 
          </Box>
        </Box>
    
        <Box className={classes.cardFooter}>
         <Box className={classes.footerItem}>
            <Button
              variant='outlined'
              className={classes.btn}
              onClick={handleCloseReviewPopup}
            > EDIT</Button>
          </Box>
          <Box className={classes.footerItem}>
              <Button
                variant='contained'
                color='primary'
                className={classes.btn}
                disabled={Cookies.get('adminToken') || isAdmin()}
                onClick={handleContinueReviewPopup}
              >CONFIRM AUTOPAY</Button>
          </Box> 
        </Box>
       
      </Box> 
    </Dialog>
  )
}

